module.exports = __webpack_public_path__ + "img/20200515_162223.48013068.jpg";